export enum ArbeitszeitAuditAenderungsTyp {
  GELOESCHT = 'gelöscht',
  NEUES_OBJEKT = 'neues Objekt',
  VERAENDERUNG = 'Veränderung',
}

const AENDERUNGS_TYP_BY_GQL_VALUE: Record<
  string,
  ArbeitszeitAuditAenderungsTyp
> = {
  GELOESCHT: ArbeitszeitAuditAenderungsTyp.GELOESCHT,
  NEUES_OBJEKT: ArbeitszeitAuditAenderungsTyp.NEUES_OBJEKT,
  VERAENDERUNG: ArbeitszeitAuditAenderungsTyp.VERAENDERUNG,
};

// Maps the GraphQL enum value (e.g. 'GELOESCHT') onto the domain enum with its
// German display value (e.g. 'gelöscht').
export function toArbeitszeitAuditAenderungsTyp(
  gqlAenderungsTyp?: string | null,
): ArbeitszeitAuditAenderungsTyp | undefined {
  return gqlAenderungsTyp
    ? AENDERUNGS_TYP_BY_GQL_VALUE[gqlAenderungsTyp]
    : undefined;
}
